import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AanvraagStatusEnum, OverzichtDTO } from '../../../_core/api/proxy';

/**
 * Shows an overview of current requests
 *
 * @export
 * @class AanvraagOverzichtComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-aanvraag-overzicht',
  templateUrl: './aanvraag-overzicht.component.html',
  styleUrls: ['./aanvraag-overzicht.component.css'],
})
export class AanvraagOverzichtComponent implements OnInit {
  @Input() aanvragenOverzicht: OverzichtDTO[];
  @Output() onOpenDetail = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<string>();

  status = AanvraagStatusEnum;
  statusAgerond = 'AFGEROND';

  get lopendeAanvragen() {
    if (this.aanvragenOverzicht) {
      return this.aanvragenOverzicht.filter(
        (aanvraag) =>
          aanvraag.status === AanvraagStatusEnum.AanvraagAfwerken ||
          aanvraag.status === AanvraagStatusEnum.InAanmaak ||
          aanvraag.status === AanvraagStatusEnum.KlaarOmInTeDienen,
      );
    }
  }

  get ingediendeAanvragen() {
    if (this.aanvragenOverzicht) {
      return this.aanvragenOverzicht.filter(
        (aanvraag) =>
          aanvraag.status !== AanvraagStatusEnum.AanvraagAfwerken &&
          aanvraag.status !== AanvraagStatusEnum.InAanmaak &&
          aanvraag.status !== AanvraagStatusEnum.KlaarOmInTeDienen &&
          aanvraag.projectStatusUserCode !== this.statusAgerond,
      );
    }
  }

  get afgehandeldeAanvragen() {
    if (this.aanvragenOverzicht) {
      return this.aanvragenOverzicht.filter(
        (aanvraag) => aanvraag.status === AanvraagStatusEnum.Afgehandeld || aanvraag.projectStatusUserCode === this.statusAgerond,
      );
    }
  }

  constructor() {}

  ngOnInit() {}

  openDetail(aanvraagId: string): void {
    this.onOpenDetail.emit(aanvraagId);
  }

  deleteAanvraag(aanvraagId: string): void {
    this.onDelete.emit(aanvraagId);
  }

  canDelete(aanvraag: OverzichtDTO): boolean {
    return (
      (aanvraag && aanvraag.status === AanvraagStatusEnum.AanvraagAfwerken) || aanvraag.status === AanvraagStatusEnum.KlaarOmInTeDienen
    );
  }
}
